/**
 * @generated SignedSource<<f50beaea8abcdd4e1cf8793a2a5b4553>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHomeNavigator_store$data = {
  readonly team: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_team" | "TeamScheduleHeader_team">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_store" | "TeamScheduleHeader_store">;
  readonly " $fragmentType": "TeamHomeNavigator_store";
};
export type TeamHomeNavigator_store$key = {
  readonly " $data"?: TeamHomeNavigator_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHomeNavigator_store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "id"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHomeNavigator_store",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleHeader_store"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_store"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        }
      ],
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamHeader_team"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamScheduleHeader_team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "010f1e20cd25c0d49c39261ba415b754";

export default node;
